import { Box, BoxProps } from '@mantine/core'

import { StyledSectionContainer } from './index.styled'
type Props = {
  visible: boolean
} & BoxProps

export const SectionWrapper = ({ children, visible, ...rest }: Props) => {
  if (!visible) return null

  return (
    <Box {...rest}>
      <StyledSectionContainer>{children}</StyledSectionContainer>
    </Box>
  )
}
